import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  padding: ${spacing[2]} ${spacing[3]} ${spacing[3]};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius[14]};
  background-color: ${rawColors.structural.white};
`;

export const CardHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CardTitle = styled.h3`
  margin: 0;
  ${typographyMixin("subtitle", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: ${spacing[1]};
  cursor: pointer;
  color: ${rawColors.text.mediumEmphasis};
  border-radius: ${borderRadius.sm};

  &:hover {
    background-color: ${rawColors.structural[100]};
    color: ${rawColors.text.highEmphasis};
  }
`;

export const TableWrap = styled.div`
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  overflow: hidden;
  background-color: ${rawColors.structural.white};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  ${typographyMixin("caption", 3)}
  text-transform: uppercase;
  color: ${rawColors.text.mediumEmphasis};
  text-align: left;
  padding: ${spacing[3]} ${spacing[5]};
  background-color: ${rawColors.grey[50]};
  border-bottom: 1px solid ${rawColors.stroke[200]};
  white-space: nowrap;
`;

export const Td = styled.td`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
  padding: ${spacing[3]} ${spacing[5]};
  border-bottom: 1px solid ${rawColors.stroke[200]};
  vertical-align: middle;
`;

export const Tr = styled.tr`
  &:last-of-type ${Td} {
    border-bottom: none;
  }
`;

export const PlatformCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  ${typographyMixin("body", 3)}
`;

export const ChipRow = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing[2]};
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  padding: 2px ${spacing[1]};
  background-color: ${rawColors.structural[100]};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
  white-space: nowrap;
`;

export const MoreLink = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.primary[500]};
`;

export const FormatCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  color: ${rawColors.text.mediumEmphasis};
`;

export const ActionCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[3]};
`;
